import React from 'react'

const ArchitectYourNextModalContent = () => {
    return (
        <>
            <h3 id="homePage_offer_dialog_title" className="mt0-00 mb1-00">
                Architect Your Next (<span className="red">Update Section</span>)
            </h3>
            <p className="lh-copy mt0-00 mb2-00">
                Frame your next digital move with a clear strategy, actionable roadmap, and execution support.
            </p>
            <ul className="mt0-00 mb2-00 pl1-50 lh-copy">
                <li className="mb0-50">Priority-based sequencing of initiatives</li>
                <li className="mb0-50">Capability mapping across people, process, and technology</li>
                <li className="mb0-50">Milestone planning with measurable outcomes</li>
            </ul>
            <p className="mt0-00 mb2-00 fw6">
                Outcome: A practical path from ambition to delivery.
            </p>
        </>
    )
}

export default ArchitectYourNextModalContent